import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerLoginFormResourceBundleDe(i18next: i18n): void {
  i18next.addResourceBundle('de', 'record-it-components', {
    form: {
      LoginForm: {
        createAccount: 'Account erstellen',
        emailLabel: 'E-Mail',
        forgotPassword: 'Passwort vergessen',
        loginButtonLabel: 'Login',
        passwordLabel: 'Passwort',
        title: 'Login'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}